/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadInfoRequestState
 */
export interface CreateLeadInfoRequestState {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequestState
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequestState
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequestState
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequestState
     */
    country_id?: string;
}

/**
 * Check if a given object implements the CreateLeadInfoRequestState interface.
 */
export function instanceOfCreateLeadInfoRequestState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateLeadInfoRequestStateFromJSON(json: any): CreateLeadInfoRequestState {
    return CreateLeadInfoRequestStateFromJSONTyped(json, false);
}

export function CreateLeadInfoRequestStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadInfoRequestState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'country_id': !exists(json, 'country_id') ? undefined : json['country_id'],
    };
}

export function CreateLeadInfoRequestStateToJSON(value?: CreateLeadInfoRequestState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'country_id': value.country_id,
    };
}

